import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './AdminSubscribers.css';

const AdminSubscribers = () => {
  const [subscribers, setSubscribers] = useState([]);

  const fetchSubscribers = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/admin/subscribers`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('adminToken')}`
        }
      });
      setSubscribers(res.data);
    } catch (err) {
      console.error('Failed to fetch subscribers:', err);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this subscriber?')) return;
    try {
      await axios.delete(`${process.env.REACT_APP_API_BASE_URL}/api/admin/subscribers/${id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('adminToken')}`
        }
      });
      setSubscribers(prev => prev.filter(sub => sub._id !== id));
    } catch (err) {
      console.error('Failed to delete subscriber:', err);
      if (err.response) {
        console.error('Response data:', err.response.data);
        console.error('Status:', err.response.status);
      }
    }
  };

  useEffect(() => {
    fetchSubscribers();
  }, []);

  return (
    <div className="subscriber-page">
      <h2>Subscribed Users</h2>
      <div className="mobile-warning">
      For the best experience and all features, please use a PC or laptop
      </div>

      <table className="subscriber-table">
        <thead>
          <tr>
            <th>S.No.</th>
            <th>Email</th>
            <th className="subs-hide">Subscribed At</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {subscribers.map((sub, idx) => (
            <tr key={sub._id}>
              <td>{idx + 1}</td>
              <td>{sub.email}</td>
              <td className="subs-hide">{new Date(sub.createdAt).toLocaleString()}</td>
              <td>
                <button className="delete-btn" onClick={() => handleDelete(sub._id)}>
                  ❌ Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default AdminSubscribers;
